import { gql, useQuery } from "@apollo/client"
import { InjectedOptions } from "@oysterhr/core"
import { CompensationInsights } from "@oysterhr/schema"

export type CompensationInsightsQueryPayload = {
  compensationInsights: Pick<CompensationInsights, "seniorityLevels">
}

export const COMPENSATION_INSIGHTS_QUERY = gql`
  query CompanyGetSeniorityLevels {
    compensationInsights {
      seniorityLevels(page: 1, perPage: 50) {
        collection {
          id
          name
          description
          engagementOysterSeniorityLevel
          track
          position
        }
      }
    }
  }
`

const useSeniorityLevelsQuery = (options?: InjectedOptions<CompensationInsightsQueryPayload>) => {
  const response = useQuery<CompensationInsightsQueryPayload>(COMPENSATION_INSIGHTS_QUERY, {
    ...options,
  })

  return {
    seniorityLevels: response.data?.compensationInsights.seniorityLevels.collection ?? [],
    loading: response.loading,
  }
}

export { useSeniorityLevelsQuery }
